import { useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { supabase } from '../../../lib/supabase'
import Navbar from '../../../components/Navbar'
import Footer from '../../../components/Footer'

export default function ShopSuccess() {
  const [searchParams] = useSearchParams()
  const orderId = searchParams.get('order_id')

  useEffect(() => {
    if (!orderId) return
    supabase
      .from('orders')
      .update({ status: 'paid', updated_at: new Date().toISOString() })
      .eq('id', orderId)
      .then(() => {})
  }, [orderId])

  return (
    <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-md w-full text-center">
          <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 border border-green-200 dark:border-green-800/50 flex items-center justify-center mx-auto mb-6">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-green-600 dark:text-green-400">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
          <h1 className="text-3xl font-black uppercase tracking-tight mb-3 text-gray-900 dark:text-white">
            Order Confirmed
          </h1>
          <p className="text-gray-500 text-sm mb-2 leading-relaxed">
            Thank you for your purchase. Your order has been received and is being processed.
          </p>
          {orderId && (
            <p className="text-xs text-gray-400 mb-8 font-mono">
              Order ref: {orderId}
            </p>
          )}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/shop"
              className="border border-gray-200 dark:border-white/10 hover:border-green-600 text-gray-500 dark:text-gray-400 hover:text-green-600 dark:hover:text-white px-6 py-3 text-xs font-bold uppercase tracking-widest transition-colors"
            >
              Continue Shopping
            </Link>
            <Link
              to="/dashboard"
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 text-xs font-bold uppercase tracking-widest transition-colors"
            >
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}